import React from 'react';
import { SidebarPortal, BlockDataForm } from '@plone/volto/components';
import View from './View';
import schema from './schema';
import './style.css';

const Edit = ({ data, block, onChangeBlock, selected }) => {
  return (
    <>
      <View data={data} />

      {selected && (
        <SidebarPortal selected={selected}>
          <BlockDataForm
            schema={schema({})}
            title="Icon Link Row"
            onChangeField={(id, value) =>
              onChangeBlock(block, { ...data, [id]: value })
            }
            block={block}
            formData={data}
          />
        </SidebarPortal>
      )}
    </>
  );
};

export default Edit;
